import { useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';
import { useUpdateComponentEntryMutation } from './mutation.update.js';
import { transformComponentEntry } from './util.transform-entry.js';

function useMutateEntry(entryKey) {
  const queryClient = useQueryClient();
  const updateComponentEntry = useUpdateComponentEntryMutation();
  return useCallback(cb => {
    const updated = transformComponentEntry(queryClient, entryKey, cb);
    updateComponentEntry.mutate(updated);
    return updated;
  }, [entryKey, queryClient, updateComponentEntry]);
}

export { useMutateEntry };
//# sourceMappingURL=hook.mutate-entry.js.map
